import _ from 'lodash'

const deprecatedProperties: {
    [namespace: string]: {
        [dataType: string]: string[]
    }
} = {
    design: {
        MediaContainerWithDividers: ['charas']
    }
}

export function removeDeprecatedProperties(namespace: string, data: any) {
    if (!data.type) {
        return
    }
    const propertiesToRemove = deprecatedProperties[namespace]?.[data.type]
    if (!propertiesToRemove) {
        return
    }
    for (const property of propertiesToRemove) {
        if (_.has(data, [property])) {
            delete data[property]
        }
    }
}
